module.exports = __webpack_public_path__ + "img/goal-15.2eaf425a.png";